import { render, staticRenderFns } from "./GroupButton.vue?vue&type=template&id=29b3857c&"
import script from "./GroupButton.vue?vue&type=script&lang=js&"
export * from "./GroupButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports